import { render, staticRenderFns } from "./DocumentsManagerContractors.vue?vue&type=template&id=07456920"
import script from "./DocumentsManagerContractors.vue?vue&type=script&lang=ts"
export * from "./DocumentsManagerContractors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07456920')) {
      api.createRecord('07456920', component.options)
    } else {
      api.reload('07456920', component.options)
    }
    module.hot.accept("./DocumentsManagerContractors.vue?vue&type=template&id=07456920", function () {
      api.rerender('07456920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/documents/manager/DocumentsManagerContractors.vue"
export default component.exports